module.exports = __webpack_public_path__ + "13e02dc692f1ae62cae90b7c56cebd47.svg";